// generated with https://chatgpt.com/canvas/shared/67c0782997dc8191b2902ea72f642842, and changed afterwards
export function createEnumMapper<
  FromEnum extends Record<string, string>,
  TargetEnum extends { [K in keyof FromEnum]: keyof FromEnum }, // Ensures values of FromEnum map to keys in EnumTargetType
>(_: FromEnum, toEnum: TargetEnum) {
  return (value: FromEnum[keyof FromEnum]): TargetEnum[keyof FromEnum] => {
    if (value in toEnum) {
      return toEnum[value];
    }

    throw new Error(`Unexpected enum value: ${value}`);
  };
}
